
import { Grid } from '@mui/material'
import { H_REFERENCIAL_LEXICONS, H_RPQS_REFERENCIALS } from 'account/constants/AccessRulesConstants'
import { orderBy } from 'lodash'
import React, { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import DashboardAction from 'referencial/components/dashboard/actions/DashboardAction'
import ReferencialCard from 'referencial/components/dashboard/components/ReferencialCard'
import ReferencialAction from 'referencial/action/ReferencialAction'
import { PATH_REFERENCIAL_RPQS_LINK } from 'home/constants/RouteConstants'
import RpqsAction from 'rpqs/actions/RpqsAction'

const COLLECTIVITES = 'COLLECTIVITES'
const MANAGEMENT_ENTITIES = 'ENTITES_DE_GESTION'
const LEXICONS = 'LEXICONS'

const RpqsReferencialsDashboardApp = () => {
    const {
        city,
        collectivities,
        managementUnits,
        contact,
        referencialSandreCodes,
        sandreCodes,
        contributor,
        sector,
    } = useSelector(store => ({
        city: store.DashboardReducer.city,
        collectivities: store.RpqsReducer.collectivities,
        managementUnits: store.RpqsReducer.managementUnits,
        contact: store.DashboardReducer.contact,
        referencialSandreCodes: store.ReferencialReducer.referencialSandreCodes,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        contributor: store.DashboardReducer.contributor,
        sector: store.DashboardReducer.sector,
    }), shallowEqual)

    const referencials = useMemo(() => [
        city,
        contact,
        contributor,
        sector,
    ], [city, contact, contributor, sector])

    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: i18n.RPQSReferencials,
        href: PATH_REFERENCIAL_RPQS_LINK,
    }], [])

    const dispatch = useDispatch()

    useEffect(() => {
        if (!sandreCodes.length) {
            dispatch(ReferencialAction.fetchSandreCodes())
        }
        dispatch(DashboardAction.fetchEveryCount())
        dispatch(ReferencialAction.fetchReferencialSandreCodes())
        dispatch(RpqsAction.fetchAllCollectivities())
        dispatch(RpqsAction.fetchAllManagementUnits())
        dispatch(ReferencialAction.fetchReferencialSandreCodes())
    }, [])

    const refNumber = useMemo(() => sandreCodes.filter(sandreCode => referencialSandreCodes.some(rsc => rsc.code && rsc.field === sandreCode.field)).length, [referencialSandreCodes, sandreCodes])

    const ref = useMemo(() => ({
        ...referencials,
        collectivities: {
            id: COLLECTIVITES,
            icon: 'people',
            url: 'collectivities',
            name: i18n.collectivities,
            date: '',
            number: collectivities.length,
            habilitation: H_RPQS_REFERENCIALS,
        },
        managementUnits: {
            id: MANAGEMENT_ENTITIES,
            icon: 'build',
            url: 'managementEntities',
            name: i18n.managementEntities,
            date: '',
            number: managementUnits.length,
            habilitation: H_RPQS_REFERENCIALS,
        },
        lexicons: {
            id: LEXICONS,
            icon: 'list',
            url: 'lexicons',
            name: i18n.lexicons,
            date: '',
            number: sandreCodes.length - refNumber,
            habilitation: H_REFERENCIAL_LEXICONS,
        },
    }), [referencials, collectivities, managementUnits, sandreCodes, refNumber])

    const referencialFiltered = useMemo(() => orderBy(ref, 'name', 'asc').filter(r => componentHasHabilitations(r.habilitation)), [ref])

    return (
        <Grid container spacing={1}>
            {referencialFiltered.map(referencial => (
                <ReferencialCard
                    key={referencial.id}
                    referencials={referencials}
                    referencialSandreCodes={referencialSandreCodes}
                    url={referencial.url}
                    name={referencial.name}
                    icon={referencial.icon}
                    id={referencial.id}
                    number={referencial.number}
                    link={PATH_REFERENCIAL_RPQS_LINK}
                    sizeCard={4}
                />
            ))}
        </Grid>
    )
}

export default RpqsReferencialsDashboardApp